export default class AddCardManager {

    constructor({executePaymentWithUserWebCardRequest, userWebStoreCardRequest}) {
        this.userWebStoreCardRequest = userWebStoreCardRequest;
        this.executePaymentWithUserWebCardRequest = executePaymentWithUserWebCardRequest;
        this.eventDelegation();
    }

    eventDelegation() {
        this.storeCardCheckboxToggle();
        this.payWithUserCardClickEvent();
    }

    storeCardCheckboxToggle() {
        const storeCardCheckbox = document.querySelector('input[name="store-card"]');
        if (storeCardCheckbox) {
            if (storeCardCheckbox.checked) {
                this.toggleUserWebStoreCardRequest(storeCardCheckbox).then(r => {
                });
            }
            this.storeCardCheckboxClickEvent(storeCardCheckbox);
        }
    }

    storeCardCheckboxClickEvent(storeCardCheckbox) {
        storeCardCheckbox.addEventListener("click", (card) => {
            this.toggleUserWebStoreCardRequest(card.currentTarget).then();
        });
    }

    async toggleUserWebStoreCardRequest(elem) {
        const data = new FormData();


        if (elem.dataset.order) {
            data.append('orderNumber', elem.dataset.order);
        }
        if (elem.checked) {
            data.append('create', elem.checked);
        }
        if (elem.dataset.appusertoken) {
            data.append('user', elem.dataset.appusertoken);
        }


        const url = this.userWebStoreCardRequest;

        return await fetch(url, {
            method: 'POST',
            body: data
        }).then();
    };

    payWithUserCardClickEvent() {
        const payUserCard = document.querySelector('button[name="pay-user-card"]');
        if (!payUserCard) return;

        payUserCard.addEventListener("click", (button) => {
            payUserCard.setAttribute('disabled', 'disabled');
            this.payToUserCard(button.currentTarget).then(r => {
                window.location = r.url
            });
        });
    }

    async payToUserCard(elem) {
        const data = new FormData();
        if (elem.dataset.userCardId) {
            data.append('userCardId', elem.dataset.userCardId);
        }
        if (elem.dataset.amount) {
            data.append('amount', elem.dataset.amount);
        }
        if (elem.dataset.bookingId) {
            data.append('bookingId', elem.dataset.bookingId);
        }
        if (elem.dataset.bookingToken) {
            data.append('bookingToken', elem.dataset.bookingToken);
        }
        if (elem.dataset.giftCardId) {
            data.append('giftCardId', elem.dataset.giftCardId);
        }
        if (elem.dataset.giftCardToken) {
            data.append('giftCardToken', elem.dataset.giftCardToken);
        }
        if (elem.dataset.appusertoken) {
            data.append('user', elem.dataset.appusertoken);
        }
        if (elem.dataset.budgetId) {
            data.append('budgetId', elem.dataset.budgetId);
        }
        if (elem.dataset.userAdminId) {
            data.append('userAdminId', elem.dataset.userAdminId);
        }
        if (elem.dataset.userAdminWebId) {
            data.append('userAdminWebId', elem.dataset.userAdminWebId);
        }
        if (elem.dataset.panelId) {
            data.append('idPanel', elem.dataset.panelId);
        }

        const url = this.executePaymentWithUserWebCardRequest;
        return await fetch(url, {
            method: 'POST',
            body: data
        }).then(r => r.json());
    }
}
